<template>
  <div class="flex flex-wrap">
    <Form :pageType="pageType" :onSubmit="onSubmit" :alertType="alertType" :alertMessage="alertMessage"
      :clientProps="currentClient" :showModal="showModal" :toggleModal="toggleModal" />
    <Detail :showModal="showModalDetail" :toggleModal="toggleModalDetail" :itemID="itemID" />
    <div v-if="showModal" class="opacity-25 fixed inset-0 z-40 bg-black"></div>
    <div v-if="showModalDetail" class="opacity-25 fixed inset-0 z-40 bg-black"></div>
    <confirm-dialogue ref="confirmDialogue"></confirm-dialogue>

    <div class="w-full px-4">
      <div class="relative flex flex-col min-w-0 break-words bg-white w-full mb-6 shadow-lg rounded">
        <div class="rounded-t bg-white mb-0 px-6 py-6">
          <div class="text-center flex justify-between">
            <h6 class="text-blueGray-700 text-xl font-bold">User Management</h6>
            <a class="bg-emerald-500 text-white active:bg-emerald-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
              v-on:click="onClickAdd" href="#">
              Create New
            </a>
          </div>
        </div>
        <div class="block w-full overflow-x-auto">
          <!-- Projects table -->
          <table class="items-center w-full bg-transparent border-collapse">
            <thead>
              <tr>
                <th
                  class="px-6 bg-blueGray-50 text-blueGray-500 align-middle border border-solid border-blueGray-100 py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left">
                  ID
                </th>
                <th
                  class="px-6 bg-blueGray-50 text-blueGray-500 align-middle border border-solid border-blueGray-100 py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left">
                  Full Name
                </th>
                <th
                  class="px-6 bg-blueGray-50 text-blueGray-500 align-middle border border-solid border-blueGray-100 py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left">
                  Username
                </th>
                <th
                  class="px-6 bg-blueGray-50 text-blueGray-500 align-middle border border-solid border-blueGray-100 py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left">
                  Role
                </th>
                <th
                  class="px-6 bg-blueGray-50 text-blueGray-500 align-middle border border-solid border-blueGray-100 py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left">
                  Last Login
                </th>
                <th
                  class="px-6 bg-blueGray-50 text-blueGray-500 align-middle border border-solid border-blueGray-100 py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in users" :key="item.id">
                <th class="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4 text-left">
                  {{ item.id }}
                </th>
                <td class="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4">
                  {{ item.fullname }}
                </td>
                <td class="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4">
                  {{ item.username }}
                </td>
                <td class="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4">
                  {{ item.role_name }}
                </td>
                <td class="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4">
                  {{ item.date }}
                </td>
                <td class="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4">
                  <a href="#" v-on:click="editClient(item, 0)"
                    class="bg-emerald-500 text-white active:bg-emerald-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150">Edit</a>
                  <a href="#" v-on:click="deleteItem(item)"
                    class="bg-red-500 text-white active:bg-red-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150">Delete</a>
                </td>
              </tr>
            </tbody>
          </table>
          <Pagination :totalCounts="totalCounts" :onPageChange="handlePageChange" />

        </div>
      </div>
    </div>
  </div>
</template>
<script>
import UserDataService from "@/services/UserDataService";
import { UseAppStore } from '@/stores/AppStore';
import Form from "@/views/admin/user-management/Form.vue";
import Detail from "@/views/admin/user-management/Detail.vue";
import Pagination from "@/components/Paginate/Pagination.vue";
import ConfirmDialogue from "@/components/ConfirmDialogue/ConfirmDialogue.vue";
import constants from "@/constants";
import ErrorHandler from "@/ErrorHandler";

export default {
  setup() {
    const appStore = UseAppStore();
    appStore.resetBreadcrumbs();
    appStore.putBreadcrumbs("dashboard", "Dashboard", "/admin/dashboard")
    appStore.putBreadcrumbs("user_management", "User Management", "/admin/user-management")

    return {
      appStore
    }
  },
  components: {
    Form,
    Detail,
    Pagination,
    ConfirmDialogue
  },
  data() {
    return {
      totalCounts: 0,
      users: [],
      currentClient: {
        id: null,
        User: ""
      },
      currentIndex: -1,
      showModal: false,
      showModalDetail: false,
      alertType: '',
      alertMessage: '',
      pageType: 'Add',
      itemID: ''
    }
  },
  methods: {
    handlePageChange(page) {
      UserDataService.getAll(constants.pageLimit, page)
        .then(response => {
          this.users = response.data["data"]["listofregistrationdata"];
        })
        .catch(e => {
          ErrorHandler(e)
        });
    },
    countDownTimer(countDown, callback) {
      if (countDown > 0) {
        setTimeout(() => {
          countDown -= 1
          this.countDownTimer(countDown, callback)
        }, 1000)
      } else {
        this.alertType = ''
        if (callback != undefined) {
          callback()
        }
      }
    },
    toggleModal() {
      this.showModal = !this.showModal;
    },
    toggleModalDetail() {
      this.showModalDetail = !this.showModalDetail;
    },
    onClickAdd() {
      this.currentClient = {
        id: null,
        User: ""
      };
      this.showModal = !this.showModal;
      this.pageType = 'Add'
    },
    retrieveItems() {
      UserDataService.getAll()
        .then(response => {
          this.users = response.data["data"]["listofregistrationdata"];
          this.totalCounts = response.data["data"]["count"];
        })
        .catch(e => {
          ErrorHandler(e)
        });
    },
    refreshList() {
      this.retrieveItems();
      this.currentClient = null;
      this.toggleModal()
    },
    editClient(item, index) {
      this.currentClient = {
        id: item.id,
        fullname: item.fullname,
        username: item.username,
        role: item.role_name,
        role_id: item.role_id
      };
      console.log("current user >>> ", this.currentClient);
      this.currentIndex = item ? index : -1;
      this.showModal = !this.showModal;
      this.pageType = 'Edit'
    },
    async deleteItem(item) {
      const ok = await this.$refs.confirmDialogue.show({
        title: 'Attention',
        message: 'Are you sure you want to delete this item?',
        okButton: 'Delete',
      })

      if (ok) {
        UserDataService.delete(item.id)
          .then(() => {
            this.alertType = 'Success'
            this.alertMessage = 'User successfuly deleted'
            this.countDownTimer(3, this.retrieveItems)
          })
          .catch(e => {
            ErrorHandler(e)
          });
      }
    },
    searchClient() {
      UserDataService.findByTitle(this.title)
        .then(response => {
          this.clients = response.data;
          this.editClient(null);
          console.log(response.data);
        })
        .catch(e => {
          ErrorHandler(e)
        });
    },
    onSubmit(client) {
      if (this.currentClient != null && this.currentClient.id != null) {
        this.updateItem(client)
      } else if (this.currentClient != null && this.currentClient.id == null) {
        this.addItem(client)
      }
    },
    addItem(client) {
      var data = {
        fullname: client.fullname,
        username: client.username,
        password: client.password,
        role_id: client.role_id,
      };
      UserDataService.create(data)
        .then(() => {
          this.alertType = 'Success'
          this.alertMessage = 'User successfuly created'
          this.countDownTimer(3, this.refreshList)
        })
        .catch(e => {
          this.alertType = 'Failed'
          this.alertMessage = e.response.data.code_message
          this.countDownTimer(3)
        });
    },
    updateItem(client) {

      var data = {
        fullname: client.fullname,
        username: client.username,
        password: client.password,
        role_id: client.role_id,
      };
      console.log(data)
      UserDataService.updatData(this.currentClient.id, data)
        .then(() => {
          this.alertType = 'Success'
          this.alertMessage = 'User successfuly updated'
          this.countDownTimer(3, this.refreshList)
        })
        .catch(e => {
          this.alertType = 'Failed'
          this.alertMessage = e.response.data.code_message
          this.countDownTimer(3)
        });
    }
  },
  mounted() {
    this.retrieveItems();
  }
};
</script>
